import './global.css';

import { persistor, setupStore } from 'redux/store';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import i18n from 'config/i18n';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { PersistGate } from 'redux-persist/integration/react';
import { Provider } from 'react-redux';
import { ruRU } from '@mui/x-date-pickers/locales';
import { ThemeProvider } from '@mui/material';
import timezone from 'dayjs/plugin/timezone';
import { useTranslation } from 'react-i18next';
import utc from 'dayjs/plugin/utc';

import AppRouter from 'components/main/AppRouter';

import { mainTheme } from 'config/themes';
import { NotificationsProvider } from 'providers/NotificationsProvider';

dayjs.extend(utc);
dayjs.extend(timezone);

export const MainApp = () => {
  const { i18n: { language } } = useTranslation();
  const renderContent = () => (
    <LocalizationProvider localeText={language === 'ru' ?
      ruRU.components.MuiLocalizationProvider.defaultProps.localeText : undefined}
                          adapterLocale={i18n.language}
                          dateAdapter={AdapterDayjs}>
      <ThemeProvider theme={mainTheme}>
        <Provider store={setupStore}>
          <PersistGate loading={null} persistor={persistor}>
            <NotificationsProvider>
              <AppRouter />
            </NotificationsProvider>
          </PersistGate>
        </Provider>
      </ThemeProvider>
    </LocalizationProvider>
  );

  return renderContent();
};
